export var formPortalTokens = {
  defaultSize: "m",
  defaultColumns: [{
    xs: 12,
    sm: 3
  }, {
    xs: 12,
    sm: 9
  }],
  defaultGap: [0, 24],
  vertical: true,
  formGroup: {
    defaultLabelAndControlGap: [0, 16],
    secondaryTextSize: {
      s: "xs",
      m: "s",
      l: "m"
    }
  },
  sectionDividerColor: function sectionDividerColor(_ref) {
    var color = _ref.color;
    return color.border.hr.base;
  },
  secondaryTextColor: function secondaryTextColor(_ref2) {
    var color = _ref2.color;
    return color.text.secondary.base;
  },
  errorTextColor: function errorTextColor(_ref3) {
    var color = _ref3.color;
    return color.importance.danger.base;
  }
};